import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { useTranslation } from '@mint-lib/i18n';
import { useIsAllowedPermission } from '@mint-lib/profile-helpers';
import { Divider } from '@mint-lib/tw-components';

import BaseSelect from '../../components/BaseSelect.jsx';
import {
  getMapLabelByOperationType,
  OperationTypesEnum,
} from '../../constants/singleFlow.js';
import { type FlowFormInput } from '../../types/singleFlow.js';

type Props = {
  index: number;
};

const OperationSection: FC<Props> = ({ index }) => {
  const { t } = useTranslation('@myn/approval_v2');

  const isReadOnly = !useIsAllowedPermission('approvalFlowFeature:modify');
  const { control } = useFormContext<FlowFormInput>();

  const mapLabelByOperationType = getMapLabelByOperationType(t);
  const operationOptions = [
    {
      value: OperationTypesEnum.enum.and,
      label: mapLabelByOperationType[OperationTypesEnum.enum.and],
    },
    {
      value: OperationTypesEnum.enum.or,
      label: mapLabelByOperationType[OperationTypesEnum.enum.or],
    },
    {
      value: OperationTypesEnum.enum.then,
      label: mapLabelByOperationType[OperationTypesEnum.enum.then],
    },
  ];

  return (
    <div className="flex items-center gap-2">
      <div className="grow">
        <Divider orientation="horizontal" />
      </div>
      <div className="shrink-0">
        <Controller
          control={control}
          name={`approvers.${index}.operation`}
          render={({ field }) => {
            return (
              <BaseSelect
                id={`approver-select-operation-${index}`}
                a11yLabel="Select the connector"
                size="small"
                value={field.value ?? ''}
                onChange={(option) => field.onChange(option.value)}
                options={operationOptions}
                disabled={isReadOnly}
              />
            );
          }}
        />
      </div>
      <div className="grow">
        <Divider orientation="horizontal" />
      </div>
    </div>
  );
};

export default OperationSection;
